(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-products-filtered"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('AllProductsFilterForm');
    if (!form) return;

    // Detectar si estamos en HOME (/) — si es así, redirigir a /collections/all con los filtros
    // porque Shopify solo procesa ?filter= params en URLs /collections/xxx
    const isHome = window.location.pathname === '/' || window.location.pathname === '';
    const targetPath = isHome ? '/collections/all' : window.location.pathname;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const params = new URLSearchParams();
      const inputs = form.querySelectorAll('input[type="checkbox"]:checked, input[type="number"]');
      inputs.forEach(function(inp) {
        if (inp.value !== '' && !inp.disabled) params.append(inp.name, inp.value);
      });
      const qs = params.toString();
      window.location.href = targetPath + (qs ? '?' + qs : '');
    });

    // También arreglar el link "Limpiar" para que vaya al lugar correcto
    const clearBtn = form.querySelector('.ap-filters__btn--clear');
    if (clearBtn) clearBtn.href = targetPath;

    // ═══ Sort dropdown — respeta targetPath (mismo fix que filtros) ═══
    const sortSelect = document.querySelector('[data-ap-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        // Mantener otros params (filtros ya aplicados) + agregar sort_by
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', this.value);
        window.location.href = targetPath + '?' + params.toString();
      });
    }

    // ═══ Drawer mobile — abrir/cerrar ═══
    const drawer = document.getElementById('ApFiltersDrawer');
    const openers = document.querySelectorAll('[data-ap-filters-open]');
    const closers = document.querySelectorAll('[data-ap-filters-close]');
    const openDrawer = (e) => {
      if (e) e.preventDefault();
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ap-filters-open');
      openers.forEach(o => o.setAttribute('aria-expanded', 'true'));
    };
    const closeDrawer = (e) => {
      if (e) e.preventDefault();
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ap-filters-open');
      openers.forEach(o => o.setAttribute('aria-expanded', 'false'));
    };
    openers.forEach(o => o.addEventListener('click', openDrawer));
    closers.forEach(c => c.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const init = () => {
      const toggles = document.querySelectorAll('[data-mobile-toggle]');
      const closers = document.querySelectorAll('[data-mobile-close]');
      const drawer = document.querySelector('[data-mobile-drawer]');
      if (!drawer || !toggles.length) return;

      const open = (e) => {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mobile-drawer-open');
        toggles.forEach(t => t.setAttribute('aria-expanded', 'true'));
      };
      const close = (e) => {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mobile-drawer-open');
        toggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
      };

      toggles.forEach(t => {
        t.replaceWith(t.cloneNode(true));
      });
      document.querySelectorAll('[data-mobile-toggle]').forEach(t => t.addEventListener('click', open));
      closers.forEach(c => c.addEventListener('click', close));

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);

    // ═══ Sticky header con efecto shrink al scrollear (FIX HOVER / FLICKER LOOP) ═══
    const initStickyShrink = () => {
      const header = document.querySelector('.site-header');
      if (!header) return;

      // Hysteresis: doble umbral para evitar bucles de parpadeo por cambios de altura
      const THRESHOLD_ON = 120;  // Se activa al bajar de 120px
      const THRESHOLD_OFF = 40;   // Se desactiva solo al volver a subir de 40px
      let isScrolled = false;
      let ticking = false;

      const update = () => {
        const y = window.scrollY;

        if (!isScrolled && y > THRESHOLD_ON) {
          isScrolled = true;
          header.classList.add('is-scrolled');
          document.body.classList.add('header-scrolled');
        } else if (isScrolled && y < THRESHOLD_OFF) {
          isScrolled = false;
          header.classList.remove('is-scrolled');
          document.body.classList.remove('header-scrolled');
        }
        ticking = false;
      };

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }, { passive: true });
      update();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyShrink);
    } else {
      initStickyShrink();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.delaferia-hero');
    roots.forEach(root => {
      const track = root.querySelector('.delaferia-hero__track');
      const dots  = root.querySelectorAll('.delaferia-hero__dot');
      const slides = root.querySelectorAll('.delaferia-hero__slide');
      if (!track || slides.length < 2) return;

      const autoplay = root.dataset.autoplay === 'true';
      const interval = parseInt(root.dataset.interval, 10) || 5000;
      let current = 0;
      let timer;

      const goTo = idx => {
        current = (idx + slides.length) % slides.length;
        track.style.transform = `translateX(-${current * 100}%)`;
        dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === current);
          d.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
      };

      const start = () => {
        if (!autoplay) return;
        stop();
        timer = window.setInterval(() => goTo(current + 1), interval);
      };
      const stop = () => timer && window.clearInterval(timer);

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => { goTo(i); start(); });
      });

      const prevBtn = root.querySelector('[data-hero-prev]');
      const nextBtn = root.querySelector('[data-hero-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); start(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); start(); });

      // Pausar autoplay al hover / focus
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      // Respetar prefers-reduced-motion
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    // Toggle filtros mobile drawer
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-filters-toggle]')) {
        document.body.classList.toggle('filters-open');
        const panel = document.querySelector('[data-filters-panel]');
        if (panel) panel.setAttribute('aria-hidden', document.body.classList.contains('filters-open') ? 'false' : 'true');
      }
      if (e.target.closest('[data-filters-close]')) {
        document.body.classList.remove('filters-open');
        const panel = document.querySelector('[data-filters-panel]');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      }
    });
    // ESC cierra drawer mobile
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('filters-open')) {
        document.body.classList.remove('filters-open');
      }
    });
    // Sort dropdown → redirige con sort_by query param
    const sortSelect = document.querySelector('[data-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
    // Auto-submit form al cambiar cualquier checkbox (mejora UX)
    const filterForm = document.querySelector('[data-filters-form]');
    if (filterForm) {
      let submitTimeout;
      filterForm.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"]')) {
          clearTimeout(submitTimeout);
          submitTimeout = setTimeout(() => filterForm.submit(), 400);
        }
      });
    }

    // Cargar más productos: link real (funciona sin JS) + auto-carga al acercarse scrolleando
    function initLoadMore() {
      const wrap = document.querySelector('[data-load-more]');
      if (!wrap) return;
      const btn = wrap.querySelector('[data-load-more-btn]');
      const grid = document.querySelector('[data-collection-grid]');
      if (!btn || !grid) return;
      let loading = false;
      let observer;

      function setLoading(state) {
        loading = state;
        btn.classList.toggle('is-loading', state);
        const label = btn.querySelector('[data-load-more-label]');
        if (label) label.textContent = state ? 'Cargando…' : 'Cargar más productos';
      }

      function loadNext(e) {
        if (e) e.preventDefault();
        if (loading) return;
        setLoading(true);
        fetch(btn.href)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newGrid = doc.querySelector('[data-collection-grid]');
            if (newGrid) grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
            const newWrap = doc.querySelector('[data-load-more]');
            if (observer) observer.disconnect();
            if (newWrap) {
              wrap.outerHTML = newWrap.outerHTML;
              initLoadMore();
            } else {
              wrap.remove();
            }
            if (window.initAjaxCart) window.initAjaxCart();
          })
          .catch(() => setLoading(false));
      }

      btn.addEventListener('click', loadNext);

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) loadNext();
          });
        }, { rootMargin: '600px' });
        observer.observe(btn);
      }
    }
    initLoadMore();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // 1. Galería interactiva + Modal Lightbox Zoom
  (function() {
    var mainImage = document.getElementById('ProductMainImage');
    var thumbBtns = document.querySelectorAll('.product-page__thumb-btn');
    var modal = document.getElementById('ProductImageModal');
    var modalImg = document.getElementById('ProductModalImage');
    var closeBtns = document.querySelectorAll('[data-modal-close]');

    if (!mainImage) return;

    // Cambiar imagen principal al hacer clic en las miniaturas
    thumbBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var newSrc = btn.getAttribute('data-main-src');
        var newSrcset = btn.getAttribute('data-main-srcset');
        var newZoom = btn.getAttribute('data-zoom-src');

        if (newSrc) mainImage.src = newSrc;
        if (newSrcset) mainImage.srcset = newSrcset;
        if (newZoom) mainImage.setAttribute('data-zoom-src', newZoom);

        thumbBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    // Abrir modal zoom al hacer clic en la imagen principal
    if (mainImage.parentElement) {
      mainImage.parentElement.addEventListener('click', function() {
        if (!modal || !modalImg) return;
        var zoomSrc = mainImage.getAttribute('data-zoom-src') || mainImage.src;
        modalImg.src = zoomSrc;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    }

    // Cerrar modal
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  })();

  // 2. Sincroniza el selector de variante con precio e ID
  (function() {
    var jsonEl = document.getElementById('ProductVariantsJSON');
    var form = document.getElementById('ProductForm');
    if (!jsonEl || !form) return;
    var variants = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var priceDiscount = document.querySelector('[data-price-discount]');
    var priceInstallment = document.querySelector('[data-price-installment]');
    var addBtn = form.querySelector('button[type="submit"]');
    var selects = form.querySelectorAll('.product-page__option-select');
    if (!selects.length) return;

    function formatMoney(amountCents) {
      return '$' + Math.round(amountCents / 100).toLocaleString('es-CL');
    }

    function findVariant() {
      var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.filter(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return opts[i] === val; });
      })[0];
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      idInput.value = variant.id;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      var hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceWas) {
        if (hasDiscount) { priceWas.textContent = formatMoney(variant.compare_at_price); priceWas.hidden = false; }
        else { priceWas.hidden = true; }
      }
      if (priceDiscount) {
        if (hasDiscount) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          priceDiscount.textContent = '-' + pct + '%';
          priceDiscount.hidden = false;
        } else { priceDiscount.hidden = true; }
      }
      if (addBtn) {
        if (variant.available) { addBtn.disabled = false; addBtn.textContent = 'Agregar al carrito'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Agotado'; }
      }
      if (priceInstallment) {
        priceInstallment.textContent = '💳 3 cuotas de ' + formatMoney(Math.round(variant.price / 3)) + ' sin interés';
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    }

    var stickyPrice = document.querySelector('[data-sticky-price]');

    selects.forEach(function (s) { s.addEventListener('change', updateUI); });
    updateUI();

    var stickyBar = document.querySelector('[data-sticky-bar]');
    var stickyAddBtn = document.querySelector('[data-sticky-add]');
    var originalBuy = document.querySelector('[data-product-buy-box]');
    if (stickyBar && originalBuy && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px' });
      obs.observe(originalBuy);
    }
    if (stickyAddBtn && addBtn) {
      stickyAddBtn.addEventListener('click', function () { addBtn.click(); });
    }
  })();

  // 3. Fetch Shopify product recommendations (AJAX)
  (function() {
    const container = document.getElementById('product-recommendations');
    if (!container) return;
    const url = container.dataset.url;
    if (!url) return;

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newRecs = doc.getElementById('product-recommendations');
        if (newRecs && newRecs.innerHTML.trim().length > 0) {
          container.innerHTML = newRecs.innerHTML;
          const fallback = document.querySelector('[data-fallback-related]');
          if (fallback && newRecs.querySelector('.product-page__rec-grid')) {
            fallback.style.display = 'none';
          }
          if (window.initAjaxCart) window.initAjaxCart();
        }
      })
      .catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.prod-slider').forEach(function(slider) {
      const track = slider.querySelector('[data-prod-slider-track]');
      const prev = slider.querySelector('[data-prod-slider-prev]');
      const next = slider.querySelector('[data-prod-slider-next]');
      if (!track || !prev || !next) return;

      const scrollBy = function(dir) {
        const item = track.querySelector('.prod-slider__item');
        if (!item) return;
        const step = item.offsetWidth + 16;
        track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      };
      prev.addEventListener('click', function() { scrollBy(-1); });
      next.addEventListener('click', function() { scrollBy(1); });

      // Enable/disable buttons según scroll position
      const updateButtons = function() {
        const atStart = track.scrollLeft <= 4;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        prev.disabled = atStart;
        next.disabled = atEnd;
      };
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
